import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { usePermission } from "./usePermission";
import Spinner from "../components/common/Spinner";

const resolvePermissionsObject = (state) => {
  const payload = state?.permissions?.permissions;
  if (!payload || typeof payload !== "object") return {};
  if (payload.permissions && typeof payload.permissions === "object") {
    return payload.permissions;
  }
  return payload;
};

export default function ProtectedRoute({ permission, children }) {
  const { can, canByKey, hasPolicyRole, isSuperAdmin } = usePermission();
  const location = useLocation();
  const reduxAccessToken = useSelector((state) => state.user?.accessToken);
  const permissionsLoading = useSelector((state) => state.permissions?.loading);
  const permissionsLoaded = useSelector((state) => state.permissions?.loaded);
  const permissionsObject = useSelector(resolvePermissionsObject);
  const storedAccessToken = localStorage.getItem("accessToken");
  const isAuthenticated = Boolean(reduxAccessToken || storedAccessToken);

  if (!isAuthenticated) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  const hasAnyPermissions = Object.keys(permissionsObject).length > 0;
  const shouldWaitForPermissions =
    Boolean(permission) &&
    !hasAnyPermissions &&
    (permissionsLoading || !permissionsLoaded);

  if (shouldWaitForPermissions) {
    return <Spinner loading={true} />;
  }

  const isAllowed = (() => {
    if (!permission) return true;
    if (isSuperAdmin || hasPolicyRole("VIEWER")) return true;
    if (Array.isArray(permission)) {
      return permission.some((entry) => {
        if (typeof entry === "string") return canByKey(entry);
        return can(entry.module, entry.subModule, entry.action);
      });
    }
    if (typeof permission === "string") {
      return canByKey(permission);
    }
    return can(permission.module, permission.subModule, permission.action);
  })();

  if (permission && !isAllowed) {
    return <Navigate to="/403" replace />;
  }

  console.debug("[Route] ProtectedRoute", {
    pathname: location.pathname,
    permission,
    isAllowed,
  });

  return children;
}
